import { Link } from "react-router-dom";
import { hotTopics, categoryNameMap } from "@/mocks/site";

function trendIcon(t: string) {
  if (t === "up")
    return <i className="ri-arrow-up-line text-sm text-primary-600" aria-hidden="true"></i>;
  if (t === "down")
    return <i className="ri-arrow-down-line text-sm text-secondary-500" aria-hidden="true"></i>;
  return <i className="ri-arrow-right-line text-sm text-foreground-400" aria-hidden="true"></i>;
}

export default function HotList() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-700">
            热点坐标 · HOT BOARD
          </p>
          <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            此刻值得围观的话题
          </h2>
          <p className="mt-2 max-w-xl text-sm text-foreground-600">
            基于近期公开讨论热度排序，每条都链向对应的完整事件地图。
          </p>
        </div>
        <Link
          to="/events"
          className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-md border border-primary-200 bg-primary-50 px-4 py-2 text-sm font-medium text-primary-700 transition-colors hover:bg-primary-100"
        >
          查看全部事件地图
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-8 grid grid-cols-1 gap-3 lg:grid-cols-2">
        {hotTopics.map((t) => (
          <Link
            key={t.rank}
            to={`/events/${t.slug}`}
            className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 hover:bg-background-100 md:p-5"
          >
            <span
              className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-md font-heading text-lg font-black ${
                t.rank <= 3
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-200 text-foreground-600 group-hover:bg-accent-200 group-hover:text-accent-900"
              }`}
            >
              {t.rank}
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-center gap-2">
                <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
                  {t.category}
                </span>
                <span className="flex items-center gap-1 text-xs text-foreground-500">
                  {trendIcon(t.trend)}
                  {t.delta}
                </span>
              </span>
              <span className="mt-1.5 block truncate text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-700 md:text-base">
                {t.title}
              </span>
            </span>
            <span className="flex shrink-0 items-center gap-1.5 text-accent-700">
              <i className="ri-fire-fill" aria-hidden="true"></i>
              <span className="font-heading text-base font-bold">{t.heat}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}